import React from 'react';
import { FormStateProvider, FormStateContext } from '@/contexts/FormStateContext';
import { DocumentSelectionModal } from './index';

/**
 * Pushes selection changes made inside the modal back out to a consumer that owns
 * its own selectedDocs state (local useState or Redux). Fires only on real changes,
 * not the initial seed.
 */
const SelectionSync = ({ onSelectedDocsChange }) => {
  const { state } = React.useContext(FormStateContext);
  const selectedDocs = state.selectedDocs;
  const isInitial = React.useRef(true);

  React.useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    onSelectedDocsChange(selectedDocs);
  }, [selectedDocs]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

/**
 * Controlled adapter around DocumentSelectionModal for the tool surfaces that keep
 * their own selectedDocs state rather than living inside a page-level FormStateProvider.
 * Seeds an internal FormStateProvider from `selectedDocs` each time it mounts (i.e. each
 * time the modal opens) and reports the resulting selection through `onSelectedDocsChange`.
 */
export const DocumentSelectionModalControlled = ({ selectedDocs, onSelectedDocsChange, ...modalProps }) => {
  const [initialFormState] = React.useState({
    question: '',
    agentName: '',
    tags: [],
    selectedDocs: selectedDocs || [],
    selectedCsvDocs: [],
    noRetrieval: false,
    onlySources: [],
    excludeSources: [],
    invalidCsvDocIds: [],
    csvErrorByDocId: {},
  });

  return (
    <FormStateProvider initialStateParam={initialFormState}>
      <SelectionSync onSelectedDocsChange={onSelectedDocsChange} />
      <DocumentSelectionModal {...modalProps} />
    </FormStateProvider>
  );
};
